export default {
    AGENDADA: 'Agendado',
    ENCERRADA: 'Encerrado',
    SUSPENSA: 'Suspenso',
    ABERTA: 'Aberto',
    CANCELADA: 'Cancelado',
    REVOGADA: 'Revogado',
    ANULADA: 'Anulado',
    HOMOLOGADA: 'Homologado'
}
